import type { ArticleBlock } from '@/mocks/articles';

type ArticleBodyProps = {
  blocks: ArticleBlock[];
};

export default function ArticleBody({ blocks }: ArticleBodyProps) {
  return (
    <div className="space-y-5">
      {blocks.map((block, index) => {
        if (block.type === 'h2') {
          return (
            <h2
              key={`h-${index}`}
              id={`h-${index}`}
              className="scroll-mt-28 font-heading text-xl md:text-2xl font-bold text-foreground-950 pt-4"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === 'quote') {
          return (
            <blockquote
              key={`q-${index}`}
              className="border-l-4 border-primary-500 bg-primary-50 rounded-r-lg px-5 py-4 my-2"
            >
              <p className="font-heading text-base md:text-lg leading-relaxed text-primary-900">
                {block.text}
              </p>
            </blockquote>
          );
        }
        if (block.type === 'list') {
          return (
            <ul key={`l-${index}`} className="space-y-3 my-2">
              {block.items.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm md:text-[15px] leading-relaxed text-foreground-700">
                  <span className="w-5 h-5 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs leading-none" aria-hidden="true" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={`p-${index}`} className="text-sm md:text-[15px] leading-loose text-foreground-700">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}